import React, { FunctionComponent } from "react";
import styles from "./Card.module.scss";
import CardProps from "./CardProps.interface";

import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import Dictionary from "components/Dictionary/Dictionary";
import Anchor from "components/Anchor/Anchor";
import getRelativeUrl from "helpers/getRelativeUrl";

const Card: FunctionComponent<CardProps> = (props): JSX.Element => {
    const [wrapperElementRef, inView] = useInView({ triggerOnce: false, threshold: 0.45, rootMargin: "50% -40px 50% 0px" });
    const isInViewClass = inView === true ? "in_view" : undefined;

    const image = props.image ? props.image : undefined;
    const imageCrop = getImageCrop(image?.umbracoFile.crops, props.imageCrop, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, image?.umbracoWidth, image?.umbracoHeight);

    return (
        <div className={combineClasses(styles.wrapper, isInViewClass)} ref={wrapperElementRef}>
            <Anchor className={styles.inner} to={getRelativeUrl(props._url)}>
                {/* Media */}
                {props.image ? (
                    <div className={styles.image_wrapper}>
                        <ImageViewer src={props.image.umbracoFile.src} focalPoint={props.image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    </div>
                ) : null}

                {/* Content */}
                <div className={styles.content}>
                    {props.heading ? (
                        <DynamicHeading className={styles.heading} headlineSize={"H6"} headlineWeight={"H4"}>{props.heading}</DynamicHeading>
                    ) : null}

                    {props.description ? (
                        <Paragraph className={styles.text} innerHTML={props.description} />
                    ) : null}

                    <span className={styles.link}>
                        <span className={styles.link_adjustment}>
                            <Dictionary name="BLOCKS.BLOG_CAROUSEL.READ_MORE" />
                        </span>
                    </span>
                </div>
            </Anchor>
        </div>
    );
};

export default Card;